import { AnyAction } from 'redux';

// Types
import { ProductProps } from 'types/Product.types';
import { OrderFormState } from 'types/RootState.types';

export function getBatchingFailureItems(action: AnyAction, state: OrderFormState) {
  const batchingFailureIds = action?.error?.inconsistentBatchProducts || state.inconsistentBatchProducts;
  const items = action?.result?.orderForm?.items || state.items;

  if (!batchingFailureIds || !items) return {};

  const batchingFailureItems = items?.filter((item: ProductProps) => batchingFailureIds.includes(item.id));
  const allItemsHaveBatchingFailure = items.length === batchingFailureIds.length;

  return {
    batchingFailureItems,
    allItemsHaveBatchingFailure,
  };
}
